import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import {
  SeekerDashboardService,
  DashboardOverview,
  DashboardNextPayment,
  DashboardQuickActions,
} from '../../services/seeker-dashboard.service';
import { TranslatePipe } from '../../../../../core/pipes/translate.pipe';

@Component({
  selector: 'app-seeker-header',
  standalone: true,
  imports: [CommonModule, TranslatePipe],
  templateUrl: './seeker-header.html',
  styleUrl: './seeker-header.scss',
})
export class SeekerHeader implements OnInit {
  private dashboardService = inject(SeekerDashboardService);
  private router = inject(Router);

  overview: DashboardOverview = {
    propertiesOwned: 0,
    propertiesRented: 0,
    pendingInstallments: 0,
    overdueInstallments: 0,
    openSupportTickets: 0,
  };
  nextPayment: DashboardNextPayment | null = null;
  quickActions: DashboardQuickActions | null = null;
  loading = true;

  ngOnInit(): void {
    this.dashboardService.getDashboard().subscribe({
      next: (res) => {
        this.overview = res.overview;
        this.nextPayment = res.nextPayment;
        this.quickActions = res.quickActions;
        this.loading = false;
      },
      error: () => {
        this.loading = false;
      },
    });
  }

  navigate(path: string): void {
    this.router.navigateByUrl(path);
  }
}
